import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentServices {
  private _paymentApi = `${environment.administration}/organizations`;
  private _emailApi = `${environment.integration}/UserEmailExistsAcrossOrganizations`;

  constructor(private _http: HttpClient) { }

  // Send form data to API and return Observable
  signUp(formData: any) {
    return this._http.post<any>(`${this._paymentApi}/RegisterOrganization`, formData);
  }
  // Load existing user email
  getUserEmailExists(email: string): Observable<any> {
    return this._http.get<any>(`${this._emailApi}/${email}`);
  }

}
